import React, { useMemo } from 'react';
import { Link } from "react-router-dom";
import Card from '../../../../componentes/contenedores/Card';
import Page from '../../../../componentes/plantilla/Page';
import { useContextEmpleado } from '../../../../contexto/empleado/EmpleadoContext';
import Tablas from "../../../../componentes/tablas/TablasGenerico";
import ModalClientes from "./ModalClientes";
import EliminarCliente from "./EliminarClientes";
import { useContextUsuario } from "../../../../contexto/usuario/UsuarioContext";
import { createRoot } from "react-dom/client";

const HomeClientesEmpleados = () => {
  const { listaClientes, setListaClientes, ActualizarLista } = useContextEmpleado();
  const { token } = useContextUsuario();

  const datos = {
    titulo: {
      titulo: "Edición de clientes",
      url: "/app/admin/clientes/gestionar",
      tituloUrl: "clientes",
      nombreUrl: "Nuevo"
    }
  }

  // Funciones de renderizado migradas de TablaClientes.jsx
  const renderTelefonos = (telefonos) => {
    if (!Array.isArray(telefonos) || telefonos.length === 0) return "—";
    return telefonos.map(t => t.telefono).join("<br>");
  };

  const renderEmpresas = (empresas) => {
    if (!Array.isArray(empresas) || empresas.length === 0) return "—";
    return empresas.map(e => e.nombre).join("<br>");
  };

  const columnasClientes = useMemo(
    () => [
      { targets: 0, title: "Nombre Completo", data: "nombreCompleto" },
      { targets: 1, title: "RTN", data: "rtn" },
      { targets: 2, title: "Identidad", data: "identidad" },
      { targets: 3, title: "Correo", data: "correo" },
      { targets: 4, title: "Empresas", data: "ClienteEmpresas", render: renderEmpresas },
      { targets: 5, title: "Teléfonos", data: "ClienteTelefonos", render: renderTelefonos },
      {
        targets: 6,
        title: "Opciones",
        data: null,
        orderable: false,
        searchable: false,
        className: 'dt-center all', // CLAVE: Clase 'all' para asegurar visibilidad en responsive
        createdCell: (td, cellData, rowData) => {
          const root = createRoot(td);
          root.render(
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "1em" }}>
              <ModalClientes
                datos={rowData}
                token={token}
                setListaClientes={setListaClientes}
                ActualizarLista={ActualizarLista}
              />
              <EliminarCliente
                datos={rowData}
                token={token}
                setListaClientes={setListaClientes}
                ActualizarLista={ActualizarLista}
              />
            </div>
          );
        },
      },
    ],
    [token, setListaClientes, ActualizarLista]
  );

  return (
    <Page datos={datos}>
      <Card titulo="Lista de Clientes">
        <Tablas
          datos={listaClientes}
          columnas={columnasClientes}
          id="tablaClientes"
        />
      </Card>
    </Page>
  )
}

export default HomeClientesEmpleados;